import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalClose() {
  return <section className="py-20 px-2 sm:px-6 lg:px-8 text-center mt-[-60px] mb-[-60px]" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mt-[30px] mb-[30px]" data-id="element-40">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-zinc-500 mb-6" data-id="element-41">
            You don't need more information.
          </h2>
          <h3 className="text-4xl sm:text-5xl md:text-6xl font-serif text-white mb-12" data-id="element-42">
            You need better{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light italic" data-id="element-43">
              interpretation.
            </span>
          </h3>

          <Button href="https://www.paypal.com/ncp/payment/F62R9QBLPNFEA" className="min-w-[280px]" onClick={() => {
          if (!(window as any).__checkout_fired) {
            ;
            (window as any).__checkout_fired = true;
            (window as any).fbq?.('track', 'InitiateCheckout', {
              content_type: 'product',
              content_category: 'Self Improvement',
              content_name: 'The Dream Decoding System™',
              content_ids: ['dream_decoding_system'],
              contents: [{
                id: 'dream_decoding_system',
                quantity: 1
              }],
              value: 19.99,
              currency: 'USD'
            });
          }
        }} data-id="element-44">
            Get Instant Access — $19.99
          </Button>
          <p className="text-center text-sm text-zinc-500 flex items-center justify-center gap-1.5 mt-[0px] mb-[0px]" data-id="element-45">
            <LockIcon className="w-3.5 h-3.5" data-id="element-46" />
            Secure checkout
          </p>
        </motion.div>
      </div>
    </section>;
}